import React, { useState, useEffect } from "react";
import "./UploadFile.css";
import { getGridcoFileTypes, uploadGridcoFile, getGridcoUploadedFile } from "../../Rest_api/RestApi";
import PaginationTable from "../../components/Table.tsx";
import { Upload } from "lucide-react";
import Loading from "../../components/Loading";
import { DynamicDatePicker } from "../../components/DatePicker";
import { getLast7DaysDateRange } from "./const";


const GridcoUploadFile = () => {
  const [selectedFileType, setSelectedFileType] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [fileDescription, setFileDescription] = useState("");
  const [files, setFiles] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const [fileTypeList, setFileTypeList] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [loading, setLoading] = useState(true);
  const [selectedDateRange, setSelectedDateRange] = useState(getLast7DaysDateRange());

  const columnNames = ["Uploaded At", "Type", "Date", "File Link", "Description"];
  const columnKeys = ["uploaded_at", "type", "user_date", "file_url", "description"];

  useEffect(() => {
    const fetchFileTypes = async () => {
      try {
        const response = await getGridcoFileTypes();
        setFileTypeList(response || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching file types:", error);
        setLoading(false);
      }
    };

    fetchFileTypes();
    getFiles();
  }, []);

  useEffect(() => {
    if (selectedDateRange) {
      const filteredFiles = files.filter((file) => {
        if (!file.user_date) return false;
        const fileDate = new Date(file.user_date);
        return (
          fileDate >= selectedDateRange.startDate &&
          fileDate <= selectedDateRange.endDate
        );
      })
      setFilteredFiles(filteredFiles);
    }
  }, [files, selectedDateRange]);

  useEffect(() => {
      const filteredFiles = files.filter((file) =>
        file.type.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredFiles(filteredFiles);
    }, [files, searchText]);

  const getFiles = async () => {
    try {
      const res = await getGridcoUploadedFile();
      setFiles(res);
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
    }
  };

  const handleFileTypeChange = (event) => {
    setSelectedFileType(event.target.value);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setUploadedFile(file);
    }
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setFileDescription(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedDate) {
      alert("Please select a date before submitting!");
      return;
    }
    if (!selectedFileType) {
      alert("Please select a file type before uploading!");
      return;
    }
    if (!uploadedFile) {
      alert("Please upload a file before submitting!");
      return;
    }
    
    const formData = new FormData();
    formData.append("file", uploadedFile);
    formData.append("date", selectedDate);
    formData.append("type_name", selectedFileType);
    formData.append("description", fileDescription);

    try {
      await uploadGridcoFile(formData);
      alert(`File "${uploadedFile.name}" submitted successfully on ${selectedDate} as "${selectedFileType}"!`);
      getFiles(); // Refresh the file list
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Error uploading file. Please try again.");
    }

    // Reset form state
    setSelectedFileType("");
    setUploadedFile(null);
    setFileDescription("");
    setSelectedDate("");
  };

  return (
    <>
      <div className="m-4" style={{ height: "unset!important" }}>
        {loading && <Loading />}

        <form
          onSubmit={handleSubmit}
          id="GridcoUploadFile"
          className="w-full mb-4 flex gap-10 items-center bg-white p-3 rounded-lg"
        >
          <div className="flex gap-3 items-center">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              1
            </div>
            <input
              type="date"
              required={true}
              value={selectedDate}
              onChange={handleDateChange}
              placeholder="MM/DD/YYYY"
              className="border border-[#C5C5CBD9] rounded-lg p-2 text-[#8C8A96]"
            />
          </div>

          <div className="flex gap-3 items-center">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              2
            </div>

            <select
              required={true}
              className="border border-[#C5C5CBD9] rounded-lg p-2 max-w-[200px] text-[#8C8A96] "
              value={selectedFileType}
              onChange={handleFileTypeChange}
            >
              <option value="" disabled>
                Select File Type
              </option>
              {fileTypeList.map((fileType, index) => (
                <option key={index} value={fileType}>
                  {fileType}
                </option>
              ))}
            </select>
          </div>
              
          <div className="flex gap-3 items-center">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              3
            </div>

            <div className="">
              <label className="downloadButton cursor-pointer font-medium flex items-center gap-3 h-[38px]">
                Upload File <Upload size={20} />
                <input
                  required={true}
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />
              </label>
              {uploadedFile && (
                <p className="uploaded-file-name">
                  Uploaded File: {uploadedFile.name}
                </p>
              )}
            </div>
          </div>

          <div className="flex gap-3 items-center flex-1">
            <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center text-white text-xs font-semibold shadow-sm">
              4
            </div>
            <div className="flex-1">
              <input
                type="text"
                placeholder="File discription"
                className="border border-[#C5C5CBD9] rounded-lg p-2  text-[#8C8A96] w-full"
              />
            </div>
          </div>

          <button
            type="submit"
            className="bg-primary text-white h-[38px] px-6 rounded-full text-sm"
          >
            Submit
          </button>
        </form>

        <div className="bg-white py-2 px-4 rounded-lg mb-4 flex items-center gap-3 justify-between">
          <h2 className="chartHeading w-60">Uploaded Files</h2>
          <div className="flex gap-3 items-center">
            <input
              placeholder="Search files by type"
              className="border h-[2.5rem] rounded-lg p-2"
              type="search"
              onChange={(e) => setSearchText(e.target.value)}
            />
            <span className="text-zinc-300">|</span>
            <DynamicDatePicker
              setDate={(date) => {
                setSelectedDateRange(date[0]);
              }}
              defaultDates={selectedDateRange}
            />
          </div>
        </div>

        {/* <div className="page-container">
      {/* <div>Temeporarly Disabled on QA</div> */}

        {/* <>
      <div className="header">
        <h1>Upload Form</h1>
      </div>
      <form onSubmit={handleSubmit} id="gridco-upload" className="section">
        <div className="taskbar">
          <div className="date">
            <label>
              Select Date:
              <input type="date" value={selectedDate} onChange={handleDateChange} />
            </label>
          </div>
          <div className="select">
            <label>
              Select File Type:
              {loading ? (
                <p>Loading file types...</p>
              ) : (
                <select
                  className="file-type-dropdown"
                  value={selectedFileType}
                  onChange={handleFileTypeChange}
                >
                  <option value="" disabled>
                    Select File Type
                  </option>
                  {fileTypeList.map((fileType, index) => (
                    <option key={index} value={fileType}>
                      {fileType}
                    </option>
                  ))}
                </select>
              )}
            </label>
          </div>
          <div className="upload-section">
            <label className="button-upload">
              Upload File:
              <input
                type="file"
                style={{ display: "none" }}
                onChange={handleFileUpload}
              />
            </label>
            {uploadedFile && (
              <p className="uploaded-file-name">
                Uploaded File: {uploadedFile.name}
              </p>
            )}
          </div>

          <div className="description-section">
            <label className="description-label">
              File Description:
              <input
                type="text"
                value={fileDescription}
                onChange={handleDescriptionChange}
                placeholder="Enter file description"
                className="description-input"
              />
            </label>
          </div>

          <div className="submit-section">
            <button type="submit" className="submit-button">
              Submit
            </button>
          </div>
        </div>
      </form> */}

        <PaginationTable
          columnNames={columnNames}
          columnKeys={columnKeys}
          data={filteredFiles.reverse()}
          ITEMS_PER_PAGE={15}
          hyperlinkColumns={{ file_url: "file_url" }}
          hyperlinkText="View File"
        />
      </div>

      <div className="gna-footer-container">
        <div className="grid grid-cols-2 justify-between gap-5 ">
          <p className="gna-footer-text">
            Powered by <strong>GNA Energy</strong>
          </p>
          <strong className="gna-footer-text  text-end">Beta Version</strong>
        </div>
      </div>
    </>
    
  );
};

export default GridcoUploadFile;
